import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container login-register-wrapper-box-container" }
const _hoisted_2 = { class: "row my-5 justify-content-center" }
const _hoisted_3 = { class: "col-lg-7 col-12" }
const _hoisted_4 = { class: "container my-3" }
const _hoisted_5 = {
  class: "d-flex flex-column gap-4",
  style: {"padding":"30px"}
}
const _hoisted_6 = { class: "title-2 text-grey-900" }
const _hoisted_7 = { class: "body text-grey-900" }

import {
    reactive,
    onMounted,
    onBeforeUnmount,
    ref,
  } from 'vue'

  import { onKeyStroke } from '@vueuse/core'

  // logic
  import resetPassword from '@/logic/contact/resetPassword'
  import handleEmailSent from '@/logic/contact/handleEmailSent'

  // common components
  import ContainerBox from '@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue'
  import Button from '@/components/LoginRegister/common/Button/v1/Button.vue'
  import Overlay from '@/components/LoginRegister/common/Overlay/v1/Overlay.vue'

  // composables
  import useLoading from '@/composables/useLoading'

  // state
  import email from '@/state/email'
  import showResetPopUp from '@/state/showResetPopUp'


  // Translations
  import { useI18n } from 'vue-i18n'
  interface Emits {
    (e: 'buttonClick'): void
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPopUp',
  emits: ["buttonClick"],
  setup(__props, { emit: __emit }) {

  const {t} = useI18n()


  const content = window.content

  // emit
  const emit = __emit

  // handlers
  const handleButtonClick = async () => {
    const { startLoadingThis, stopLoadingThis } = useLoading()
    showResetPopUp.value = false

    startLoadingThis()
    await resetPassword()

    stopLoadingThis()
    handleEmailSent()
  }

  onMounted(() => {
    // onKeyStroke
    const stop = onKeyStroke('Enter', () => {
      if (!email.value) return
      handleButtonClick()
    })
    onBeforeUnmount(() => stop())
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ContainerBox, { class: "position-relative" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("loginRegister.link_expired")), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("loginRegister.text_resend_link")), 1),
                _createElementVNode("div", null, [
                  _createVNode(Button, { onButtonClick: handleButtonClick }, {
                    text: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.button_resend_link")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})